import { render } from "./Thribermode.vue?vue&type=template&id=58a6d0de"
import script from "./Thribermode.vue?vue&type=script&lang=js"
export * from "./Thribermode.vue?vue&type=script&lang=js"

import "./Thribermode.vue?vue&type=style&index=0&id=58a6d0de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__